import { services } from '@repo/ui/lib/api/services/index';
import { useMutation } from '@tanstack/react-query';

interface BevaCalculationInput {
  varietyGrade: number;
  healthIndex: number;
  aestheticIndex: number;
  locationIndex: number;
  healthColumn?: number;
  aestheticColumn?: number;
}

interface BevaCalculationResult {
  message: string;
  id: number;
  beva: number;
}

interface BevaResponse {
  data: BevaCalculationResult;
  statusCode: number;
}

// Hook for calculating BEVA for inventaire
export function useCalculateBevaInventaire() {
  return useMutation<BevaCalculationResult, Error, { inventaireId: number; data: BevaCalculationInput }>({
    //@ts-ignore
    mutationFn: async ({ inventaireId, data }) => services.beva.calculateBevaForInventaire(inventaireId as number, data),
    onError: (error) => {
      console.error('Error calculating BEVA for inventaire:', error);
    },
  });
}

// Hook for calculating BEVA for essence
export function useCalculateBevaEssence() {
  return useMutation<BevaCalculationResult, Error, { essenceId: number; data: BevaCalculationInput }>({
    //@ts-ignore
    mutationFn: async ({ essenceId, data }) => {
      const response = await services.beva.calculateBevaForEssence(essenceId, data);
      return response;
    },
    onError: (error) => {
      console.error('Error calculating BEVA for essence:', error);
    },
  });
}
